{
  "name": "dokupit",
  "version": "2.9.19",
  "isBeta": false,
  "appflow": {
    "minIOS": "2.9.19",
    "minAndroid": "2.9.19"
  },
  "author": "DokuPit GmbH",
  "homepage": "https://dokupit.com",
  "scripts": {
    "ng": "ng",
    "ionic": "ionic",
    "start": "export NODE_OPTIONS=--max-old-space-size=4096 && ionic serve --hmr --external -- --disable-host-check",
    "start:ssl": "export NODE_OPTIONS=--max-old-space-size=4096 && ionic serve --hmr --external --ssl -- --disable-host-check",
    "start:prod": "export NODE_OPTIONS=--max-old-spac e-size=4096 && ionic serve --configuration production --hmr --external",
    "start:mobile:android": "export NODE_OPTIONS=--max-old-space-size=4096 && ionic cap sync && ionic cap run android -l --external --open",
    "start:mobile:ios": "export NODE_OPTIONS=--max-old-space-size=4096 && ionic cap sync && ionic cap run ios -l --external --open",
    "build": "$(pwd)/appflow-build.sh",
    "build:dev": "ng build --source-map && npm run build:manifest",
    "build:prod": "ng build --configuration production --aot && npm run build:manifest",
    "build:prod:maps": "ng build --configuration production --aot --source-map && npm run build:manifest",
    "build:mobile": "export NODE_OPTIONS=--max-old-space-size=4096 && npm run build:dev && ionic cap sync --no-build",
    "build:mobile:prod": "export NODE_OPTIONS=--max-old-space-size=4096 && npm run build:prod:maps && ionic cap sync --no-build",
    "build:manifest": "ionic live-update manifest",
    "build:release": "export NODE_OPTIONS=--max-old-space-size=4096 && npm run build:prod:maps && npm run sentry:maps && npm run sourcemaps:clean && ionic capacitor sync --prod --configuration production --no-build && npm run release:versionbump",
    "build:prod:report": "ng build --configuration production --aot --source-map && source-map-explorer www/*.js",
    "sentry:maps": "SENTRY_DP_RELEASE_VERSION=$(node ./scripts/get-release.js) && sentry-cli sourcemaps inject www && sentry-cli releases new \"app@${SENTRY_DP_RELEASE_VERSION}\" && sentry-cli releases files \"app@${SENTRY_DP_RELEASE_VERSION}\" upload-sourcemaps www --validate",
    "sentry:git": "SENTRY_DP_RELEASE_VERSION=$(node ./scripts/get-release.js) && sentry-cli releases set-commits -c \"DokuPit / AppV2@${CI_GIT_COMMIT_SHA}\" \"app@${SENTRY_DP_RELEASE_VERSION}\" && sentry-cli releases finalize \"app@${SENTRY_DP_RELEASE_VERSION}\"",
    "sourcemaps:clean": "mkdir -p ./.sourcemaps && mv ./www/*.map ./.sourcemaps",
    "release": "npm run release:versionbump && ./scripts/autofix-git-changes-release.sh && ./scripts/complete-release.sh",
    "release:beta": "npm run release:versionbump:beta && ./scripts/autofix-git-changes-release.sh && ./scripts/auto-merge-beta.sh",
    "release:versionbump": "node ./scripts/release-versionupdate.js && npm run release:versionbump:android && npm run release:versionbump:ios",
    "release:versionbump:beta": "node ./scripts/release-versionupdate.js beta && npm run release:versionbump:android && npm run release:versionbump:ios",
    "release:versionbump:ios": "export DP_VERSION=$(node ./scripts/get-release.js) && ./scripts/update-version-ios.sh",
    "release:versionbump:android": "export DP_VERSION=$(node ./scripts/get-release.js) && node ./scripts/update-version-android.js",
    "symbols:ios": "npx sentry-cli upload-dif --org dokupit --project dokupit --no-zips --symbol-maps $1 $2",
    "icons:generate": "npx @capacitor/assets generate --iconBackgroundColor '#313539' --iconBackgroundColorDark '#313539' --splashBackgroundColor '#ffffff' --splashBackgroundColorDark '#313539'",
    "test": "ng test",
    "e2e": "ng e2e",
    "postinstall": "patch-package && ./scripts/replace-rxdb-premium-data.sh",
    "lint": "npm run eslint && npm run prettier -- --check",
    "fmt": "npm run eslint -- --fix && npm run prettier -- --write",
    "prettier": "prettier \"**/*.ts\"",
    "eslint": "eslint . --ext .ts",
    "prepare": "husky install"
  },
  "private": true,
  "devDependencies": {
    "@angular-devkit/architect": "^0.1802.14",
    "@angular-devkit/build-angular": "^18.2.14",
    "@angular-eslint/builder": "^18.4.3",
    "@angular-eslint/eslint-plugin": "^18.4.3",
    "@angular-eslint/eslint-plugin-template": "^18.4.3",
    "@angular-eslint/schematics": "^18.4.3",
    "@angular-eslint/template-parser": "^18.4.3",
    "@angular/cli": "^18.2.14",
    "@angular/compiler": "^18.2.13",
    "@angular/compiler-cli": "^18.2.13",
    "@angular/language-service": "^18.2.13",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^7.0.0",
    "@ionic/angular-toolkit": "^11.0.1",
    "@ionic/lab": "^3.2.15",
    "@sentry/cli": "^2.19.4",
    "@types/fabric": "^4.5.15",
    "@types/jasmine": "^3.10.8",
    "@types/jasminewd2": "^2.0.10",
    "@types/leaflet": "^1.9.16",
    "@types/leaflet.markercluster": "^1.5.5",
    "@types/uuid": "^9.0.1",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "css-loader": "^6.8.1",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^8.8.0",
    "eslint-plugin-import": "^2.27.5",
    "eslint-plugin-jasmine": "^4.1.3",
    "eslint-plugin-jsdoc": "^46.2.4",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.0.0",
    "husky": "^8.0.3",
    "jasmine-core": "^3.8.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.3.4",
    "karma-chrome-launcher": "^3.1.0",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "^4.0.1",
    "karma-jasmine-html-reporter": "^1.7.0",
    "lint-staged": "^11.2.6",
    "npm-run-all": "^4.1.5",
    "patch-package": "^7.0.0",
    "prettier": "^3.6.2",
    "properties-reader": "^2.2.0",
    "protractor": "^7.0.0",
    "readline-sync": "^1.4.10",
    "style-loader": "^3.3.3",
    "ts-node": "^10.9.1",
    "typescript": "~5.5.4"
  },
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/material": "^18.2.14",
    "@angular/material-moment-adapter": "^18.2.14",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@azure/msal-angular": "^3.0.9",
    "@azure/msal-browser": "^3.6.0",
    "@bluehalo/ngx-leaflet": "^18.0.2",
    "@bluehalo/ngx-leaflet-markercluster": "^18.0.1",
    "@capacitor-community/camera-preview": "gitlab:rdammerer/capacitor-camera-preview#capacitor7",
    "@capacitor-community/keep-awake": "^7.1.0",
    "@capacitor-community/media": "^8.0.1",
    "@capacitor-community/sqlite": "^7.0.1",
    "@capacitor-community/volume-buttons": "^7.0.0",
    "@capacitor-mlkit/barcode-scanning": "^7.2.1",
    "@capacitor/android": "^7.0.0",
    "@capacitor/app": "^7.0.0",
    "@capacitor/browser": "^7.0.0",
    "@capacitor/camera": "^7.0.0",
    "@capacitor/core": "^7.0.0",
    "@capacitor/device": "^7.0.0",
    "@capacitor/filesystem": "^7.0.0",
    "@capacitor/geolocation": "^7.0.0",
    "@capacitor/haptics": "^7.0.0",
    "@capacitor/ios": "^7.0.0",
    "@capacitor/keyboard": "^7.0.0",
    "@capacitor/live-updates": "^0.4.0",
    "@capacitor/network": "^7.0.0",
    "@capacitor/screen-orientation": "^7.0.0",
    "@capacitor/share": "^7.0.0",
    "@capacitor/splash-screen": "^7.0.0",
    "@capacitor/status-bar": "^7.0.0",
    "@capawesome/capacitor-android-edge-to-edge-support": "^7.2.2",
    "@capawesome/capacitor-app-update": "^7.0.1",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-pro": "^6.4.2",
    "@fortawesome/fontawesome-svg-core": "^6.4.2",
    "@fortawesome/free-brands-svg-icons": "^6.4.2",
    "@fortawesome/pro-light-svg-icons": "^6.4.2",
    "@fortawesome/pro-regular-svg-icons": "^6.4.2",
    "@iconfu/svg-inject": "^1.2.3",
    "@ionic/angular": "^8.6.3",
    "@ionic/cli": "^7.2.1",
    "@ionic/core": "^8.5.7",
    "@ionic/pwa-elements": "^3.3.0",
    "@ionic/storage-angular": "^4.0.0",
    "@maskito/angular": "^3.10.0",
    "@maskito/core": "^3.10.0",
    "@maskito/kit": "^3.10.0",
    "@meddv/ngx-pinch-zoom": "^18.0.1",
    "@ng-select/ng-select": "^13.9.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@pqina/angular-pintura": "^9.0.3",
    "@pqina/pintura": "^8.92.17",
    "@primeng/themes": "^19.0.6",
    "@sentry/angular": "9.27.0",
    "@sentry/capacitor": "2.0.0",
    "@sweetalert2/ngx-sweetalert2": "^11.0.0",
    "@tinymce/tinymce-angular": "^8.0.0",
    "@zip.js/zip.js": "^2.7.63",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "@zxing/ngx-scanner": "^19.0.0",
    "angular-calendar": "^0.31.0",
    "aws-sdk": "^2.1413.0",
    "buffer": "^6.0.3",
    "capacitor-blob-writer": "^1.1.17",
    "capacitor-zip": "github:allanweir/capacitor-zip#capacitor7",
    "crisp-sdk-web": "^1.0.25",
    "date-fns": "^3.2.0",
    "exceljs": "^4.4.0",
    "fabric": "^6.6.1",
    "grapesjs": "^0.20.4",
    "leaflet": "^1.9.4",
    "leaflet.markercluster": "^1.5.3",
    "leaflet.tilelayer.fallback": "^1.0.4",
    "leaflet.visualclick": "^1.1.4",
    "lodash": "^4.17.21",
    "luxon": "^3.4.4",
    "mathjs": "^14.5.3",
    "mime": "^4.0.6",
    "moment": "^2.29.4",
    "native-run": "^1.7.1",
    "ngx-autosize": "^2.0.4",
    "ngx-colors": "^3.5.2",
    "ngx-drag-drop": "^18.0.2",
    "ngx-material-timepicker": "^13.1.1",
    "ngx-quill": "^26.0.10",
    "primeng": "^18.0.2",
    "product-fruits": "^1.0.26",
    "quill": "^2.0.3",
    "quill-mention": "^6.0.2",
    "rxdb": "^16.15.0",
    "rxdb-old2": "npm:rxdb@14.17.0",
    "rxdb-premium": "^16.15.0",
    "rxdb-premium-old2": "npm:rxdb-premium@14.17.0",
    "rxjs": "^7.8.2",
    "signature_pad": "^4.1.5",
    "stream-browserify": "^3.0.0",
    "sweetalert2": "^11.22.2",
    "tippy.js": "^6.3.7",
    "util": "^0.12.5",
    "uuid": "^9.0.0",
    "xml-js": "^1.6.11",
    "zone.js": "^0.14.10"
  },
  "description": "Die Dokumentationslösung",
  "config": {
    "ionic_generate_source_map": "false"
  },
  "eslintConfig": {
    "extends": [
      "eslint:recommended",
      "plugin:@typescript-eslint/recommended",
      "plugin:@angular-eslint/recommended",
      "plugin:jasmine/recommended",
      "plugin:prettier/recommended"
    ],
    "plugins": [
      "import",
      "@typescript-eslint",
      "@angular-eslint",
      "jasmine",
      "prettier"
    ],
    "parserOptions": {
      "sourceType": "module",
      "ecmaVersion": 2022
    },
    "ignorePatterns": "**/*.html",
    "rules": {
      "import/order": "off",
      "no-var": "warn",
      "import/first": "off",
      "no-async-promise-executor": "warn",
      "prefer-const": "off",
      "no-empty": "warn",
      "import/no-duplicates": "error",
      "import/newline-after-import": "off",
      "no-inner-declarations": "warn",
      "no-useless-escape": "warn",
      "@typescript-eslint/consistent-type-imports": "off",
      "@typescript-eslint/explicit-module-boundary-types": "warn",
      "@typescript-eslint/array-type": "off",
      "@typescript-eslint/no-var-requires": "off",
      "@typescript-eslint/ban-ts-comment": "off",
      "@typescript-eslint/no-empty-function": [
        "warn",
        {
          "allow": [
            "constructors"
          ]
        }
      ],
      "@typescript-eslint/no-inferrable-types": "warn",
      "@typescript-eslint/consistent-type-assertions": "off",
      "@typescript-eslint/prefer-optional-chain": "off",
      "@typescript-eslint/no-explicit-any": "warn",
      "@typescript-eslint/no-unused-vars": "warn",
      "@typescript-eslint/ban-types": "error",
      "@angular-eslint/no-output-on-prefix": "warn",
      "@typescript-eslint/no-this-alias": "warn",
      "@angular-eslint/component-class-suffix": "off"
    }
  },
  "lint-staged": {
    "src/**/*.ts": "eslint --fix",
    "src/**/*": "prettier --write --ignore-unknown"
  },
  "accessTokens": {
    "rxdb-premium": "0xf0a2eee3b1fdffab2fa0f1b74f18388fac6ca75386b6ae6e991af2429202438a"
  }
}
